<script lang="ts" setup>
    import { onMounted } from "vue";
    import { useVuert } from "@byloth/vuert";

    import CookieAlert from "./components/alerts/CookieAlert.vue";
    import ModalsHandler from "./components/handlers/ModalsHandler.vue";
    import useUserStore from "./stores/user";

    const $vuert = useVuert();
    const $user = useUserStore();

    onMounted(async () =>
    {
        if ($user.hasAcceptedCookies === undefined)
        {
            const result = await $vuert.emit({
                type: "info",
                icon: "info",
                title: "Cookie policy",
                component: CookieAlert,
                actions: [
                    {
                        type: "primary",
                        label: "Accept",
                        callback: () => true
                    },
                    {
                        type: "secondary",
                        label: "Decline",
                        callback: () => false
                    }
                ]
            });

            if (result)
            {
                $user.acceptCookies();
            }
            else
            {
                $user.declineCookies();
            }
        }

        if ($user.isLogged) { await $user.renewToken(); }
    });
</script>

<template>
    <RouterView v-slot="context">
        <Transition name="fade" mode="out-in">
            <Component :is="context.Component" :key="context.route.path" />
        </Transition>
    </RouterView>
    <ModalsHandler />
</template>

<style lang="scss">
    @import "@/assets/styles/index";

    #app
    {
        height: 100%;

        & > .fade-enter-from,
        & > .fade-leave-to
        {
            opacity: 0;
        }
        & > .fade-enter-active,
        & > .fade-leave-active
        {
            transition: opacity 150ms linear;
        }
        & > .fade-enter-to,
        & > .fade-leave-from
        {
            opacity: 1;
        }
    }
</style>
